// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2022-11-25 21:02:04 +0100 (Fri, 25 Nov 2022) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 130875 $
// Purpose     : register global keyboard shortcuts
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import KeyHandler, {KEYDOWN} from 'react-key-handler'
import {useMemo} from 'uix/hooks'

// ---Local imports
import {AutoPortal, PortalTarget} from './portals'

// ---Exports
// Usage: <KeyboardShortCut name="Ctrl-F3" onTrigger={kbd_event => log.x(kbd_event)} />
// Usage: <KeyboardShortCut name="Ctrl-KeyS"/>
// Usage: <KeyboardShortCut name="alt-ctrl-s"/>
// Usage: <KeyboardShortCut name="ArrowUp"/>
export const KeyboardShortCut = ({name, onTrigger}) => {
  let parts = name.split('-')
  let code = parts.slice(-1)[0]
  if (code.length == 1) {
    // s => KeyS
    // https://w3c.github.io/uievents-code/#key-alphanumeric-writing-system
    code = `Key${code.toUpperCase()}`
  }
  let checks = []

  let meta = parts.slice(0, -1).map(p => p.toLowerCase())
  if (meta.includes('ctrl')) checks.push(event => event.ctrlKey)
  if (meta.includes('shift')) checks.push(event => event.shiftKey)
  if (meta.includes('alt')) checks.push(event => event.altKey)

  let onKeyHandle = useMemo(
    () => event => {
      if (checks.every(check => check(event))) {
        onTrigger(event)
        event.preventDefault()
      }
    },
    [name, onTrigger]
  )
  return (
    <AutoPortal target="GlobalShortcuts">
      <KeyHandler keyEventName={KEYDOWN} code={code} onKeyHandle={onKeyHandle} />
    </AutoPortal>
  )
}

export const GlobalKeyboardShortcuts = ({}) => <PortalTarget id="GlobalShortcuts" />
